jQuery(document).ready(function() {

	if  ( document.getElementById("form_event") !== null ) {

        const eventForm = document.getElementById("form_event");

		// Init selectpicker

		// jQuery.fn.selectpicker.Constructor.BootstrapVersion = '4'; // * Deprecated 2022-01-08
		jQuery('.kategori-select').selectpicker({
			title: 'Välj...',
			width: '100%',
			maxOptions: 3,
			selectedTextFormat: 'count > 3',
			size: 10,
			style: 'select-style',
			noneSelectedText: 'Nothing selected',
			maxOptionsText: "Du kan välja max 3 kategorier!"
		});		

		// Inputs focusin

		ca_formInputsFocusIn(eventForm);

		// Select => Categories => focusin

		const btnSelect = eventForm.querySelector('.select-style');

		btnSelect.addEventListener('focusin', (event) => {

			if (btnSelect.classList.contains('error-color') ) {

				btnSelect.classList.remove('error-color'); 
				eventForm.querySelector('#field_category .corner-label').classList.remove('error-corner-label'); // corner
				eventForm.querySelector('#field_category .err-wrapper').style.display="none";	

			}		

		});

		// ---( Evenemang : Instructors fields control )---- //

		const maxInputsAllowed = 10;
		const wrapper = document.getElementById("fields_wrapper"); 
		const btnAddInstructor = document.getElementById("btn_add"); 	

		let x = 1;

		btnAddInstructor.addEventListener('click', function (event) { 

				event.preventDefault();

				if ( x < maxInputsAllowed ) { 

						x++;

						wrapper.insertAdjacentHTML('beforeend', '<div class="rad"><label for="instructor">Namn</label><div class="input-field labeled if-extra"><input type="text" id="instructor" name="instruktor[]" class="cp-instrukt" maxlength="50" value=""><div class="corner-close-btn remove_field" data-bs-toggle="tooltip" data-bs-placement="top" title="Ta bort"><span class="icon-cross"></span></div></div></div>'); 

						var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
						var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {

							return new bootstrap.Tooltip(tooltipTriggerEl);

						});
						
				}
		});

		wrapper.addEventListener('click', function (event) {

			event.preventDefault();
			event.stopPropagation();

			let target = (event.target.classList.contains('icon-cross')) ? event.target.parentNode : event.target;
		
			if ( target.classList.contains('remove_field') ) {
			  
				let tooltip = bootstrap.Tooltip.getInstance(target);
				tooltip.hide();
				target.closest('.rad').remove();
				x--;

			}

		});

		eventForm.querySelectorAll('.inputfile').forEach( item => {

			item.addEventListener('change', function(event) {

				event.preventDefault();
				event.stopPropagation();

				if ( this.files.length == 1 ) {

					const fileName = event.target.value.split( '\\' ).pop(),
					 	  inputID = event.target.id,
						  inputBtnClearFile = eventForm.querySelector('#field_' + inputID + ' .btn-clear-file');
						
					eventForm.querySelector('#field_' + inputID + '_title' + ' .corner-label').style.display="block";
					inputBtnClearFile.innerHTML='<span class="icon-cross"></span><span>' + fileName + '</span>';
					inputBtnClearFile.style.display="block";
					eventForm.querySelector('label[for="' + inputID +'"]').style.display="none";

				}
			});
		});

		eventForm.querySelectorAll('.btn-clear-file').forEach( item => {

			item.addEventListener('click', function(event) {

				event.preventDefault();
				event.stopPropagation();

				const inputField = event.currentTarget.closest('.input-field'),
					  inputID = inputField.querySelector('.inputfile').getAttribute('id');					  

			    inputField.querySelector('.inputfile').value='';
				inputField.querySelector('label[for="' + inputID +'"]').style.display="block";
				eventForm.querySelector('#field_' + inputID + '_title' + ' .corner-label').style.display="none";
			 	event.currentTarget.style.display="none";

			});
		});

		
		jQuery(".cp-date").datepicker({
			closeText: 'Stäng',
			prevText: '< Föregående',
			nextText: 'Nästa >',
			currentText: 'Nu',
			monthNames: ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
			monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
			dayNamesShort: ['Sön','Mån','Tis','Ons','Tor','Fre','Lör'],
			dayNames: ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
			dayNamesMin: ['Sö','Må','Ti','On','To','Fr','Lö'],
			weekHeader: 'Не',
			dateFormat: 'yy-mm-dd',
			firstDay: 1,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: '',
			numberOfMonths: 1,
			showOn: 'button',
			buttonImage: '../wp-content/themes/ju-jutsukai/assets/images/icon-datepicker-grey.png',
			buttonImageOnly: true
		});

		jQuery(".cp-time").timepicker({

			timeOnlyTitle: 'Välj klockslag',
			timeText: 'Tid',
			hourText: 'Timma',
			minuteText: 'Minut',
			secondText: 'Sekund',
			millisecText: 'Millisekund',
			timezoneText: 'Tidszon',
			currentText: 'Nu',
			closeText: 'Stäng',
			timeFormat: 'HH:mm',
			amNames: ['AM', 'A'],
			pmNames: ['PM', 'P'],
			isRTL: false

      	});

		jQuery("#submit_event").click(function( event ) {

			event.preventDefault();

			var proceed = true;
			var filter 	= /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
			var fields_to_check = [
					['titel', 'title', 'text', 'input', 'Titeln är inte ifylld!'],
					['beskrivning', 'description', 'text', 'textarea', 'Beskrivningen är inte ifylld!'],
					['startdatum', 'startdate', 'text', 'input', 'Startdatumet är inte ifyllt!'],
					['starttid', 'starttime', 'text', 'input', 'Starttiden är inte ifylld!'],
					['slutdatum', 'enddate', 'text', 'input', 'Slutdatumet är inte ifyllt!'],
					['sluttid', 'endtime', 'text', 'input', 'Sluttiden är inte ifylld!'],
					['plats', 'place', 'text', 'input', 'Platsen är inte ifylld!'],
					['adress', 'address', 'text', 'input', 'Adressen är inte ifylld!'],
					['kostnad', 'cost', 'text', 'input', 'Kostnaden är inte ifylld!'],
					['kontaktperson', 'contact', 'text', 'input', 'Kontaktpersonen är inte ifylld!'],
					['epostadress', 'email', 'email', 'input', 'E-postadressen är inte ifylld eller är ogiltig!'],
					['avsandare_name', 'sendername', 'text', 'input', 'Ditt namn är inte ifyllt!'],
					['avsandare_epost', 'senderemail', 'email', 'input', 'E-postadressen är inte ifylld eller är ogiltig!']
			];

			for ( let i = 1; i < 4; i++ ) {

				if ( document.getElementById( "document"+i ).files.length != 0 ) {

						if ( document.getElementById( "document" + i + "_title" ).value.length === 0) {

								addRemoveErrorClass( '#field_document'+ i + "_title", "Rubriken är inte ifylld!", true );
								proceed = false;

						}
				}
			}

			var select = jQuery('#category-select').val().length;

			if ( select == 0 ) {

				jQuery( 'form .select-style' ).addClass( "error-color" );
				jQuery( '#field_category .corner-label' ).addClass( "error-corner-label" );
				jQuery( '#field_category .err-wrapper .error' ).empty();
				jQuery( '#field_category .err-wrapper .error' ).append( "Välj en kategori!" );
				jQuery( '#field_category .err-wrapper' ).show();
				jQuery( '#field_category .select .arr' ).addClass('err-arr');
				proceed = false;

			}

			for ( i = 0; i < fields_to_check.length; i++) {

					let name = fields_to_check[i][0];
					let id = fields_to_check[i][1];
					let type = fields_to_check[i][2];
					let obj = fields_to_check[i][3];
					let err = fields_to_check[i][4];

					let value = jQuery( obj+'[name='+name+']').val();

					switch ( type ) {
						case "text":
									if (jQuery.trim( value ).length === 0) {
											addRemoveErrorClass( '#field_'+id, err, true );
											proceed = false;
									}
									break;
						case "email":
									if (!filter.test( value )) {
											addRemoveErrorClass( '#field_'+id, err, true );
											proceed = false;
									}
									break;
					}
			}

			if ( proceed ) { // Everything looks good! proceed... //

				grecaptcha.ready(function() {

						grecaptcha.execute(wpajax.GRC_SITE_KEY, {action: 'send_event_form'})
						.then(function(token) {     // Verify the token on the server.

								document.getElementById( 'g-recaptcha-response' ).value=token;
								eventForm.querySelector('.form-img-loading').style.display="block";
								eventForm.querySelector('#submit_event .button-text').innerHTML="Skickar...";

								//var form = jQuery('#form_event')[0]; // Get form
								let data = new FormData(eventForm); // Create an FormData object
								data.append('action', 'send_event'); // admin-ajax.php uses the "action" to create two hooks: wp_ajax_youraction and wp_ajax_nopriv_youraction.

								if (data.entries) { // Workaround

										var newdata = new FormData();
										for (var p of data) {
											if (p[1]) { // p[1] is the value of form entry
												newdata.append(p[0], p[1]);
											}
										}
										data = newdata;

										// https://docs.microsoft.com/en-US/troubleshoot/developer/browsers/development-website/xmlhttprequest-not-correctly-send-formdata

								}

							let request = new XMLHttpRequest();

							request.open('POST', wpajax.WP_AJAX_URL, true);

							request.onload =  function () {

								let resp = JSON.parse(this.responseText);

								if ( this.status >= 200 && this.status < 400 ) {  // If successful

									if ( resp.status ) {

										if ( resp.code === 0 ) {

											const container = document.querySelector('.page-container .row');

											container.innerHTML='';
											
											let html_output = '<h2 class="text-center">' + resp.message + '</h2><p class="text-center">Ditt bidrag till kalendern kommer att granskas innan det läggs ut. Vi förbehåller oss rätten att justera innehållet.</p><p class="text-center">Vill du ändra, lägga till eller ta bort något efter evenemanget publiceras så ska du skicka ett vanligt e-postmeddelande till Hans Greger – <a href="hans.greger@ju-jutsu.se">hans.greger@ju-jutsu.se</a> eller Carlos Aranguiz – <a href="webbansvarig@ju-jutsu.se">webbansvarig@ju-jutsu.se</a>.</p><p class="text-center"><a class="btn btn-primary btn-lg" href="' + wpajax.WP_SITE_URL + '/skicka-evenemang/">Skapa nytt evenemang</a></p>';

											container.innerHTML=html_output;

										}

									} else {

										if ( resp.code === 1 || resp.code === 2 || resp.code === 3  ) {

											eventForm.getElementById('g-recaptcha-response').value='';
											eventForm.querySelector('.form-img-loading').style.display="none";

											const someErrors = eventForm.querySelector('.some-errors');

											someErrors.style.backgroundColor='#d95c5c';
											someErrors.style.color='#ffffff';
											someErrors.innerHTML='';
											someErrors.innerHTML='<span class="icon-stop"></span><p>' + resp.message +'</p>';
											ca_showHide(someErrors, 6000, true ); // ca_showHide(el, delay, scale?)

										}	
									}          
								}
							};
							
							request.onerror = function() {

								eventForm.getElementById('g-recaptcha-response').value='';
								eventForm.querySelector('.form-img-loading').style.display="none";

								const someErrors = eventForm.querySelector('.some-errors');

								someErrors.style.backgroundColor='#d95c5c';
								someErrors.style.color='#ffffff';
								someErrors.innerHTML='';
								someErrors.innerHTML='<span class="icon-stop"></span><p><strong>Ett oväntat fel har uppstått!</strong> Evenemanget kunde inte skickas. Försök igen senare eller kontakta webbansvarig.</p>';
								ca_showHide(someErrors, 6000, true ); // ca_showHide(el, delay, scale?)
								
							};

							request.send( data );

						});
				});

			} else {

				const someErrors = eventForm.querySelector('.some-errors');
				someErrors.innerHTML='';
				someErrors.innerHTML='<span class="icon-stop"></span><p>Formuläret innehåller fortfarande några fel! Bläddra upp och kontrollera att alla obligatoriska fält är ifyllda.</p>';
				ca_showHide(someErrors, 6000, true ); // ca_showHide(el, delay, scale?)
					
			}
		}); // End - #submit_event - Click
	}// form_event?
}); // DOM ready?
